import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";

export default class InfoBar extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.scene = scene;

        this.infoInd = 0;

        this.info = [
          gameData.maskLocalization.getLocalizedString("information.info_1", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("information.info_2", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("information.info_3", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("information.info_4", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("information.info_5", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("information.info_6", gameData.maskLocalization.isDefault)
        ];

        this.createInfoBar();
        this.tweenInInfo(true);

        this.setPosition(0, -75);
        this.scene.addToParent(this, this.scene);

        this.tweenInBar();
    }

    createInfoBar()
    {
        this.bgBar = this.scene.add.container();
        this.add(this.bgBar);
        this.bgBar.setPosition(this.scene.mid.x - 145, 0);
        this.bgBar.setScale(0, 1);

        let bar = this.scene.addImage(0, 0, "Info_Bar_Blank", this.bgBar);
        this.bg = this.scene.addImage(this.bgBar.x + 43, this.bgBar.y - 64, "Info_Bar_Tab", this);

        this.infoText = this.scene.addText(this.bgBar.x - 60, bar.height/2 - 2, 18, "0x4c4b48", gameData.fonts.din_alternatebold, this.info[this.infoInd], this.bgBar).setWordWrapWidth(500).setAlign("left");
    }

    tweenInInfo(init)
    {
        let del = 0;
        if(init) {
            this.scene.addTween(this.bg, 500, {y:0}, Phaser.Math.Easing.Quadratic.Out);
            del = 500;
        }

        this.scene.addTween(this.bgBar, 500, {scaleX:1, delay:del}, Phaser.Math.Easing.Quadratic.InOut,
            ()=>{
                this.scene.addDelay(gameData.infoDelay, ()=>{this.tweenOutInfo(true);});
            });
    }

    tweenOutInfo(reopen = false)
    {
        this.scene.killTween(this.bgBar);
        this.scene.addTween(this.bgBar, 500, {scaleX:0}, Phaser.Math.Easing.Quadratic.InOut,
            ()=>{
                if(reopen) {
                    this.infoInd++;
                    this.infoText.text = this.info[this.infoInd];

                    if(this.infoInd >= this.info.length-1) this.infoInd = 0;
                    this.tweenInInfo();
                }
            });
    }

    tweenInBar()
    {
        this.scene.addTween(this, 500, {y:0}, Phaser.Math.Easing.Quadratic.Out);
    }

    tweenOutBar()
    {
        this.scene.addTween(this, 500, {y:-75}, Phaser.Math.Easing.Quadratic.Out);
    }

    cleanUp()
    {
       this.bg.destroy();
       this.bgBar.destroy();
       this.infoText.destroy();
    }
}